import { type ReactNode } from "react";

import { TableRow } from "@vega-core/components/Deprecated/TableRow/TableRow";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  label: string;
  value?: string | null;
  isLocked?: boolean;
  action?: ReactNode;
  variant?: "default" | "large";
  noBorder?: boolean;
};

export const DetailRow = ({
  label,
  value,
  isLocked = false,
  action,
  variant = "default",
  noBorder,
}: Props) => (
  <div
    className={cnTwMerge(
      "flex w-full flex-col gap-0 border-b-1 border-border/primary sm:flex-row sm:gap-0",
      {
        "border-none": noBorder,
      },
    )}
  >
    <div className="w-full sm:font-normal sm:w-1/2">
      <TableRow className="pb-0 sm:pb-4" label={label} variant={variant} />
    </div>
    <div className="w-full sm:w-1/2 break-all">
      <TableRow
        action={action}
        className="pt-0 sm:pt-4"
        isDisabled={isLocked}
        label={value}
        labelClassName="body-base-medium sm:body-base-regular"
        variant={variant}
      />
    </div>
  </div>
);
